import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { serializeSortItem } from '@utils/utils';
import { PAGE_PATHS } from '../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/user-management/')({
  validateSearch: zodValidator(withDefaults(schema.USER_MANAGEMENT, { orderBy: [serializeSortItem({ property: 'email', isAsc: true })] })),
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.USER_MANAGEMENT });
    context.validatePermissions({ isAllowed, preload });
  },
});
